import { useState } from 'react';

/**
 * Floating version badge — sits in the bottom-right corner.
 * Shows compact "v1.0.0" pill; expands on hover/click to show full build details.
 */
export function VersionBadge() {
  const [expanded, setExpanded] = useState(false);

  const version = __APP_VERSION__;
  const sha = __BUILD_SHA__;
  const buildTime = __BUILD_TIME__;

  const formattedTime = buildTime
    ? new Date(buildTime).toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : null;

  return (
    <div className="fixed bottom-3 right-3 z-50">
      {/* Expanded panel */}
      {expanded && (
        <div
          className="absolute bottom-full right-0 mb-2 w-56 rounded-lg shadow-lg border text-xs
            bg-gray-900 dark:bg-gray-950 border-gray-700 p-3 space-y-1.5"
          onMouseEnter={() => setExpanded(true)}
          onMouseLeave={() => setExpanded(false)}
        >
          <div className="flex items-center justify-between">
            <span className="font-semibold text-white">Halo Admin</span>
            <span className="font-mono text-primary">v{version}</span>
          </div>
          <div className="border-t border-gray-700 pt-1.5 space-y-1 text-gray-400 dark:text-gray-500">
            <div className="flex justify-between">
              <span>Commit</span>
              <span className="font-mono text-gray-200">{sha.slice(0, 8)}</span>
            </div>
            {formattedTime && (
              <div className="flex justify-between">
                <span>Built</span>
                <span className="text-gray-200">{formattedTime}</span>
              </div>
            )}
            <div className="flex justify-between">
              <span>Environment</span>
              <span className="text-gray-200">{import.meta.env.VITE_ENV || 'development'}</span>
            </div>
          </div>
        </div>
      )}

      {/* Compact pill */}
      <button
        onClick={() => setExpanded(prev => !prev)}
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-mono
          bg-gray-800 dark:bg-gray-800 text-gray-400 dark:text-gray-500 border border-gray-700
          hover:bg-gray-700 transition-colors shadow-sm cursor-default select-none"
      >
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400" />
        v{version}
      </button>
    </div>
  );
}
